/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterX = createReactComponent("outline", "letter-x", "IconLetterX", [["path", { "d": "M7 4l10 16", "key": "svg-0" }], ["path", { "d": "M17 4l-10 16", "key": "svg-1" }]]);

export { IconLetterX as default };
//# sourceMappingURL=IconLetterX.mjs.map
